import angular from 'angular';
import AdvertisementComponent from './advertisement.component';

let AdvertisementModule = angular.module('home.advertisement',[])
    .component('advertisement',AdvertisementComponent);

export default AdvertisementModule;


/** WEBPACK FOOTER **
 ** ./www/components/shared/components/advertisement/advertisement.js
 **/